module.exports = __webpack_public_path__ + "static/media/google-play-th.447d0633.png";